import * as React from 'react'
import { Button } from 'react-bootstrap'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import Footer from 'components/Footer'
import Header from 'components/Header'

/**
 * 通常 QR / キャンペーン QR 共用の概要書面交付方法選択画面 (要件書 §3.1 / Rev.20 S46)。
 *
 * Phase A-2 (Rev.18 D7 移設) 後は `/summarySelectFlow/:type/:hash` ルート上で表示され、
 * SignUpIntroduction.tsx からハンドオフされる。QR-inspect (campaignQrInspectAPI) や
 * hash/RegisterKind ガードは上流の SignUpIntroduction.tsx に集約済のため、
 * 本シーンは route state 受領 + UI 分岐 + ボタン click で子画面に遷移する純粋な UI として動作する。
 *
 * Rev.20 S46:
 * - location.state.isCampaign=true (キャンペーン経路) のとき、本人確認用注意書き
 *   (運転免許証/マイナンバーカード/在留カード/パスポート/法人登記事項証明書の案内) を非表示にする。
 *   電子/紙面選択ボタンと書面交付方法に関する説明文は通常 QR と共通表示のまま。
 * - 子画面 (SummaryElectronic / SummaryPaper) への navigate にも state.isCampaign を伝搬し、
 *   最終的に CampaignSignUp / SignUpPreRegisterConnector の遷移先分岐に活用する。
 */
type LocationState = { isCampaign?: boolean } | null

const SceneComponent: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { type, hash } = useParams<{ type: string; hash: string }>()
  const isCampaign = ((location.state as LocationState) ?? null)?.isCampaign === true
  const navigateToChild = (url: string): void => {
    if (isCampaign) {
      navigate(url, { state: { isCampaign: true } })
    } else {
      navigate(url)
    }
  }

  return (
    <>
      <Header title="概要書面交付方法の確認" />
      <main>
        <section className="mx-4 my-5">
          {!isCampaign && (
            <>
              <div>
                <div>AUBEクエストコネクターの登録サイトです。ご登録にはAUBEクエストID、報酬受取用の金融機関の口座情報が必要になりますのでご用意ください。</div>
                <div>手続きを進めてい行きますと本人確認用に下記の証明書の撮影が必要になります。</div>
                <div>・運転免許証</div>
                <div>・マイナンバーカード</div>
                <div>・在留カード</div>
                <div>・パスポート</div>
              </div>
              <div className="note-warning mt-4">
                <div>法人契約の場合</div>
                <div>発行後3ヶ月以内の登記事項証明書（履歴事項全部証明書）の全ページの画像をご用意ください。（画像1枚につき10M未満）</div>
              </div>
            </>
          )}
          <h2 className="mt-5">概要書面交付方法の選択</h2>
          <p className="mt-4">AUBEクエストコネクタープランでは、概要書面、契約書面をお渡しするうえで、紙面による交付と電子書面による交付のいずれかを選択できます。</p>
          <div className="mt-4">
            <Button variant="primary" onClick={() => navigateToChild(`/summaryElectronic/${type}/${hash}`)} className="w-100 py-4">
              電子書面を選ぶ
            </Button>
          </div>
          <div className="mt-4">
            <Button variant="danger" onClick={() => navigateToChild(`/summaryPaper/${type}/${hash}`)} className="w-100 py-4">
              紙面を選ぶ
            </Button>
          </div>
          <div className="mt-5">
            <Button variant="success" href="/contactUs" className="w-100 py-4">
              お問い合わせ
            </Button>
          </div>
        </section>
      </main>
      <Footer className="mt-5" />
    </>
  )
}

export default SceneComponent
